import React, { Component } from 'react';
import './App.css';
import PropTypes, { bool } from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField'
import Button from "@material-ui/core/Button";
import _ from 'lodash';
import { withSnackbar } from 'notistack';
import qs from "qs";
import FormGroup from "@material-ui/core/FormGroup";
import axios from "axios";
import MUIDataTable from 'mui-datatables';
import {urlConfig} from './config'

const styles = theme => ({
    container: {
        position: 'relative',
    },
});


class NewCidGeneration extends Component {

    constructor(props) {
        super(props);
        let parsed = qs.parse(this.props.location.search);

        let productId = "";
        let jobid = "";

        if (parsed["productId"] && parsed["productId"].length > 0) {
            productId = parsed["productId"];
        }

        if (parsed["?jobid"] && parsed["?jobid"].length > 0) {
            jobid = parsed["?jobid"];
        }

        this.state = {
            productId: productId, jobid: jobid, responseData: null, isloading: false, isError: false, ErrorMessage: false
        };
    }

    handleChange = event => {
        this.setState({
            [event.target.name]: event.target.value,
        });
    };
    formValidation = (event) => {
        event.preventDefault();
        const { jobid, productId } = this.state
        const jobidArr = jobid.split(",")
        const productIdArr = productId.split(",")
        if (!(jobidArr.length === productIdArr.length && jobidArr.length <= 5)) {
            this.setState({
                isloading: false,
                ErrorMessage: true
            })
            return

        }
        this.cidGeneration()
    }

    cidGeneration = async (event) => {
        try {
            this.setState({
                isloading: true,
                isError: false,
                ErrorMessage:false
            })
            const { jobid, productId } = this.state
            // const getData = () => {
            //     return new Promise((resolve, reject) => {
            //         setTimeout(() => {
            //             reject({ message: "processed Successfully" })
            //         }, 2000);
            //     }
            //     )
            // }
            // const response = await getData()
            const { data } = await axios.post(`${urlConfig.cmsURL}/GetValues`, {
                jobids: jobid,
                productIds: productId,
                userEmail:sessionStorage.getItem("userEmail")
            })
            this.setState({           
                responseData: data,
                isloading: false,
                jobid: '',
                productId: ''
            })

        } catch (error) {
            this.setState({
                isloading: false,
                isError: true
            })
        }



    }

    render() {
        const { classes, theme } = this.props
        const { responseData, isloading, jobid, productId, isError, ErrorMessage } = this.state
        const Loader = () => {
            return (<div className='loader-wrapper'>
                <div class="loader"></div>
                <p>Processing...</p>
            </div>)
        }
        const columns = [
            {
                label: "productId",
                name: "productId"
            },

            {
                label: 'JOB ID',
                name: "jobid"
            },
            {
                label: 'STATUS',
                name: "status"
            }
        ]
        const options = {
            filterType: 'textField',
            pagination: false,
            selectableRows: 'none',
            print: false,
            viewColumns: false,
            responsive: 'stacked',
            search: false,
            download: false,
            filter: false,


        };
        return <React.Fragment>
            <Paper>
                <React.Fragment>
                    <Grid spacing={0}
                        container
                        direction="row"
                        justify="flex-start"
                        alignItems="center">
                        <Grid item xs={1}></Grid>
                        <Grid item xs={10}>
                            <form onSubmit={this.formValidation}>
                                <FormGroup row>
                                    <Grid spacing={2}
                                        container
                                        direction="row"
                                        justify="flex-start"
                                        alignItems="center">
                                        <Grid item xs={2}>
                                            <TextField
                                                id="outlined-jobid"
                                                label="Jobid"
                                                onChange={this.handleChange}
                                                name="jobid"
                                                margin="normal"
                                                fullWidth
                                                multiline={true}
                                                value={jobid}
                                                variant="outlined"
                                                required={true}
                                            />
                                        </Grid>
                                        <Grid item xs={4}>
                                            <TextField
                                                id="outlined-cid"
                                                label="productId"
                                                onChange={this.handleChange}
                                                name="productId"
                                                margin="normal"
                                                variant="outlined"
                                                fullWidth
                                                value={productId}
                                                required={true}
                                            />
                                        </Grid>
                                        <Grid item xs={2}>
                                            <Button disabled={isloading} variant="contained" color="primary" type="submit"
                                                size={"large"} className={classes.button}>
                                                submit
                                                {/* <PlayIcon className={classes.rightIcon}/> */}
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </FormGroup>
                            </form>
                            {/* {this.state.jobid && (this.state.jobid != "") && (this.state.cid != "") &&
                            <

                            } */}
                            <style jsx>
                                {`
                                .loader {
                                    border:8px solid #f3f3f3; /* Light grey */
                                border-top: 8px solid #ffbf00; /* Blue */
                                border-radius: 50%;
                                width: 50px;
                                height: 50px;
                                animation: spin 2s linear infinite;
                                }
                               .loader-wrapper{
                                display:flex;
                                justify-content:center;
                                align-items: center;
                                flex-direction: column;
                                margin-top:1rem;
                                }

                                @keyframes spin {
                                    0 % { transform: rotate(0deg); }
                                    100% {transform: rotate(360deg); }
                                }`}
                            </style>
                            <> {ErrorMessage ?
                               <p style={{ color: "red", fontSize:"1rem" }}>lenght of productId and jobId should match, and max only 5 jobids and productId's are allowed </p>
                                    :
                                    <>{isloading ? <Loader /> :

                                        <>{isError ? <p style={{ color: "red", fontSize: "1rem" }}>something went wrong please connect with CMS team</p> :
                                            responseData && <Grid Grid item xs={8}>
                                                {/* <MUIDataTable
                                                    title={"List of productIds and JOBIDs with status"}
                                                    data={responseData}
                                                    columns={columns}
                                                    options={options}
                                                /> */}
                                                <p style={{fontSize:"1rem" ,fontWeight:"bold"}}>Your request has been successfully submitted, the task has been accepted to process new cid creation workflow. Please check for new CID's after sometime in simulcast-helper tab with current CCSID+revised key. Eg: 02f2ea0f04ecb87a227a64813839e9c7revised</p>
                                            </Grid>}
                                        </>
                                    }</>
                                 } </> 
                                
                            
                            <br />

                        </Grid>

                    </Grid>
                </React.Fragment>
            </Paper>

        </React.Fragment>
    }
}


NewCidGeneration.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};


export default withSnackbar((withStyles(styles, { withTheme: true })(NewCidGeneration)));
